// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qk_a bhy_sn bhy_va","ForumSearch__img":"qk_b","ForumSearch__searchAdsAndShoppingAds":"qk_c","ForumSearch__results--empty":"qk_e"};